// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"b0d6af39","51":"e0039bc6","116":"227ac3ef","351":"15f5cd69","523":"4813e73b","555":"d1c572e4","779":"061ed346"}[chunkId] + ".chunk.js";
};